import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  padding: 24px 24px 32px;\n\n  input,\n  textarea {\n    border-radius: 2px;\n  }\n\n  textarea {\n    resize: none;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import styled from "styled-components";
export const Panel = styled.div.withConfig({
    componentId: "sc-18eb7b3e-0"
})(_templateObject());
